module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/plan4-2-282d82dfe83ab83ba041feb71c0537ca.webp";